import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { classes } from 'shared';

export function GeneralModal({
  open,
  onClose,
  children,
  className,
  clean,
  wide,
  thin,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  clean?: boolean;
  wide?: boolean;
  thin?: boolean;
}) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-[100] overflow-y-auto" onClose={onClose}>
        <div className="flex min-h-screen items-center justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0">
          <Transition.Child
            as={'div'}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">
            &#8203;
          </span>

          <Transition.Child
            as={'div'}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            className={classes(
              'inline-block w-full shadow-xl transition-all sm:align-middle',
              !clean && 'transform rounded-lg bg-white px-4 pb-4 pt-5 text-left align-bottom sm:my-8 sm:w-full sm:p-6',
              !clean && (wide ? 'max-w-4xl' : thin ? 'max-w-xl' : 'max-w-3xl'),
              className,
            )}>
            {children}
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
